<!-- carousel -->
<div class="carousel-container">
  @if (isLoading) {
    <mibp-loader></mibp-loader>
  }

  <div class="carousel" #carousel [ngClass]="{'hidden': isLoading}">
    @for (slide of slides; track slide; let i = $index) {
      @if (i === currentSlide) {
        <div class="image-container" @carouselAnimation>
          <div class="slide">
            <a [title]="slide.articleTitle"
              href="javascript:void(0)"
              (click)="onImageClick(slide.articleId)">
              <mibp-image [userFileId]="slide.userFileId" (imageLoaded)="imageLoaded()" [rendition]="renditionSize"></mibp-image>
            </a>
          </div>
          @if (!loadedImage) {
            <mibp-loader></mibp-loader>
          }
          @if (loadedImage) {
            <div class="title-preamble-container">
              <h3 class="my-header">{{slide.articleTitle}}</h3>
              <p>{{slide.articlePreamble}}</p>
              <button type="button" class="my-button" (click)="onReadMoreClick(slide.articleId)"><mibp-resource-string key="Global_Read_More"></mibp-resource-string></button>
            </div>
          }
        </div>
      }
    }
  </div>
</div>

<!-- prev next buttons -->
@if (slides.length > 1) {
  <button class="control prev" (click)="onPreviousClick()">
    <span translate="no" class="material-icon material-icon--gold">navigate_before</span>
  </button>
}
@if (slides.length > 1) {
  <button class="control next" (click)="onNextClick()">
    <span translate="no" class="material-icon material-icon--gold">navigate_next</span>
  </button>
}

<div class="navigation" [ngClass]="{'hidden': isLoading}">
  @if (slides.length > 1) {
    @for (slide of slides; let i = $index; track slide) {
      <button class="navigation-button" [ngClass]="{'selected': i === currentSlide}" (click)="navigateToSlide(i)"></button>
    }
  }
</div>
